import React, { useEffect, useState } from 'react';

const images = [
  'https://ncgsa.org.pk/wp-content/uploads/2025/07/DSC_0849.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2025/07/492622084_1232748342193990_481058589430418995_n-2.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2025/07/469387680_122114818898414013_1684482156551850084_n.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2025/07/DSC_4988.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2025/07/480681247_3008292842679642_1418278552963521917_n-3.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2025/07/DSC_9534.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2025/07/IAAC.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2025/07/490404728_1218274606974697_4410395853172140706_n-1.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2025/07/495150903_1238970854905072_8120939407009484819_n-1.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2025/07/DSC_8253.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2025/07/WhatsApp-Image-2025-07-15-at-09.31.19.jpg',
];

const AstronomyIntroduction = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(
      () => setActiveIndex((current) => (current + 1) % images.length),
      3000,
    );
    return () => window.clearInterval(timer);
  }, []);

  const move = (direction) => {
    setActiveIndex((current) => (current + direction + images.length) % images.length);
  };

  return (
    <section className="astronomy-introduction-section" aria-labelledby="astronomy-introduction-title">
      <div className="astronomy-introduction-inner">
        <div className="astronomy-introduction-copy">
          <p className="section-eyebrow">CONNECTING PEOPLE WITH THE COSMOS</p>
          <h1 id="astronomy-introduction-title">Introduction</h1>
          <div className="astronomy-title-line" aria-hidden="true" />
          <p>
            The Astronomy Outreach Program of the Space Education and Research Lab (SERL) at the
            National Center of GIS and Space Applications (NCGSA) is dedicated to connecting people
            with the cosmos. We bring wonders of the cosmos closer to schools, communities, and the
            general public through astronomy education and stargazing sessions. Our outreach efforts
            aim to spark curiosity, encourage scientific thinking, and inspire the next generation of
            astronomers, scientists, and space enthusiasts across Pakistan.
          </p>
          <p>
            These efforts are led by the <strong>National Astronomy Education Coordinator (NAEC) for
            Pakistan</strong>, appointed by the <strong>Office of Astronomy for Education (OAE)</strong>
            {' '}under the <strong>International Astronomical Union (IAU)</strong>. This global affiliation
            ensures our programs reflect international standards and contribute to global astronomy
            education efforts.
          </p>
        </div>

        <div className="astronomy-introduction-carousel" aria-label="Astronomy Outreach image gallery">
          <figure>
            <img src={images[activeIndex]} alt={`Astronomy Outreach activity ${activeIndex + 1}`} />
          </figure>
          <button type="button" className="astronomy-carousel-arrow previous" onClick={() => move(-1)} aria-label="Previous image">‹</button>
          <button type="button" className="astronomy-carousel-arrow forward" onClick={() => move(1)} aria-label="Next image">›</button>
          <div className="astronomy-carousel-dots" aria-label="Choose image">
            {images.map((image, index) => (
              <button
                type="button"
                className={index === activeIndex ? 'active' : ''}
                onClick={() => setActiveIndex(index)}
                aria-label={`Show image ${index + 1}`}
                aria-current={index === activeIndex ? 'true' : undefined}
                key={image}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AstronomyIntroduction;
